import { Resume } from 'src/models/resume/resume.types';
import type { ResumeCardData } from 'src/models/resumeCard';

export const getFullName = (resume: Resume | ResumeCardData): string =>
    [resume.lastName?.[0]?.string, resume.firstName?.[0]?.string, resume.middleName?.[0]?.string]
        .filter(Boolean)
        .join(' ');
